import { Card, Typography, Stack } from "@mui/material";
import { Box } from "@mui/system";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import { formatDate, formatInt } from "../../../../../../../DashboardDesktop/Anomalies/AnomaliesTabs/Utils/anomaliesColumns";

// ─────────────────────────────────────────────────────────────────────────────

interface ProblematicFtdsProps {
  brand_name: string;
  brand_id: string;
  players_total_ftd: number | string;
  brand_action_date: string;
}

export function ProblematicFtdsCard({
  brand_name,
  brand_id,
  players_total_ftd,
  brand_action_date,
}: ProblematicFtdsProps) {
  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.none.$value,
          mt: spacing.Spacing.xl.$value + "!important",
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Medium.$value,
            }}
          >
            {brand_name} ({brand_id})
          </Typography>
        </Stack>

        <Stack sx={{ mb: spacing.Spacing.xs.$value }}>
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
            }}
          >
            Players Total FTD:
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.xl.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                ml: spacing.Spacing.xs.$value,
              }}
            >
              {formatInt(players_total_ftd)}
            </Box>
          </Typography>
        </Stack>
        <Stack>
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
            }}
          >
            Brand Action Date:
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.sm.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                ml: spacing.Spacing.xs.$value,
              }}
            >
              {formatDate(brand_action_date)}
            </Box>
          </Typography>
        </Stack>
      </Card>
    </>
  );
}
export default ProblematicFtdsCard;
